<template>
  <v-sheet
    height="100%"
    class="position-relative carousel-home-item"
    width="100%"
    tile
  >
    <a :href="link" :target="target ? '_blank' : '_self'">
      <img
        class="d-block carousel-home-item-img"
        :src="
          files +
          (mobile && img_mobile
            ? img_mobile + '?resize=1&w=600'
            : img_desktop + '?resize=1&w=1920')
        "
      />
    </a>
  </v-sheet>
</template>

<script>
export default {
  props: {
    img_desktop: {
      type: String,
      required: true,
    },
    img_mobile: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    target: {
      type: Number,
      required: true,
    },
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-home-item {
  &:before {
    background-color: rgba(10, 10, 10, 0.2);
    content: "";
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &-img {
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }
}
</style>
